export const getNewDocuRows = (entitytype: any, rows: any): any[] => {
  let result: any[] = [];

  const groupByKey =
    [
      "roomtable",
      "functiontable",
      "convfunctiontable",
      "nhcdintable",
      "racktable",
      "projectcablestable",
    ].indexOf(entitytype) !== -1
      ? "rowType"
      : false;

  try {
    if (groupByKey) {
      const key = groupByKey;
      /**
       * @type {Map<string,Array>}
       */
      const groups = new Map();
      rows.forEach((row: any) => {
        const rowGroupKey = row[key] || "";
        if (!groups.has(rowGroupKey)) {
          groups.set(rowGroupKey, []);
        }
        groups.get(rowGroupKey).push(row);
      });

      groups.forEach((val, key) => {
        if (key.trim().length > 0) {
          result.push({ isGroupHeading: true, text: key, rowIdx: key });
        }
        val.forEach((row: any, idx: number) => {
          row.rowIdx = `${key}_${idx}`;
          result.push(row);
        });
      });
    } else {
      rows.forEach((row: any, idx: number) => {
        result.push({ ...row, rowIdx: idx });
      });
    }
  } catch (err) {
    console.log(err);
  }

  return result;
};
